import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import ContentIntelligenceWrapper from "@components/layouts/contentIntelligenceWrapper";
import CategoryPage from "@components/contentintelligence/categoryPage";
import categories from "@lib/contentintelligence/categories";

export default function ContentIntelligenceHome(): ReactElement {
    return (
        <ContentIntelligenceWrapper>
            <CategoryPage />
        </ContentIntelligenceWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    if (!categories.includes(context.query.tool as string)) {
        return {
            notFound: true,
        };
    }

    return await getPageProps(context, "home");
};
